import api from '@/services/api';

export const state = () => ({
  stocks: [],
  meta: {},
  isLoading: false,
});

export const getters = {
  stocks: () => stocks,
  meta: () => meta,
  isLoading: () => isLoading,
};

export const mutations = {
  SET_STOCKS(state, data) {
    state.stocks = data;
  },
  SET_META(state, data) {
    state.meta = data;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
};

export const actions = {
  async getStocksData({ commit }, params) {
    try {
      commit('SET_LOADING', true);
      const { data } = await api.getStocksData(params);

      commit('SET_STOCKS', data.data);
      commit('SET_META', data.meta);
      commit('filter/SET_FILTER', params, { root: true });
    } catch (error) {
      console.log(error);
      this._vm.$toast('Network Error!', {
        type: 'error',
        timeout: 3000,
      });
    } finally {
      commit('SET_LOADING', false);
    }
  },
};
